import './App.css';
import React, { useState } from 'react';
import Header from './Components/Header';
import { BrowserRouter as Router } from 'react-router-dom';
import { Routes, Route } from 'react-router-dom';
import WeddingRSVP from './Components/WeddingRSVP';
import AuthContext from './Components/Usecontexts/Maincontext';
import { useMediaQuery } from '@mui/material';
import Popup from './Components/Popup';
import { useEffect } from 'react';
import Main from './Components/Blog/Main';
import DetailedBlog from './Components/Blog/DetailedBlog';
import { useTranslation } from 'react-i18next';
import i18n from './i18n';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { IconButton } from '@mui/material';
import { useTheme } from '@mui/material/styles';




function App() {







  // const [menupress, setMenupress] = useState(false);
  // const [popup, setPopup] = useState(false);
  // const [checked, setChecked] = useState(false);
  // const [issucceeded, setIssucceeded] = useState(false);
  // const [isvalidationerror, setIsvalidationerror] = useState(false);
  // const [isincontactpage, setIsincontactpage] = useState(false);
  // const [ishomepage, setIshomepage] = useState(true);
  // const [isinprojectpage, setIsinprojectpage] = useState(false);
  // const [value, setValue] = useState(0);
  // const [currentlang, setCurrentlang] = useState('en');
  // const [isLangChanging, setIsLangChanging] = useState(false);
  // const theme = useTheme();
  // const ismd = useMediaQuery(theme.breakpoints.up('md'));

  // useEffect(() => {
  //   // Trigger the animation
  //   setIsLangChanging(true);

  //   // Change the language
  //   i18n.changeLanguage(currentlang);
  //   document.body.dir = i18n.dir();

  //   // After the animation duration, reset the animation state
  //   const animationDuration = 500; // Duration in milliseconds
  //   const timer = setTimeout(() => {
  //     setIsLangChanging(false);
  //   }, animationDuration);

  //   // Clean up the timer
  //   return () => clearTimeout(timer);
  // }, [currentlang]);

  // const mainContentStyle = {
  //   transition: 'margin 0.3s ease-out',
  // };




  return (
    // <AuthContext.Provider value={{menupress, currentlang,setCurrentlang,checked,setChecked,value,setValue,isvalidationerror,setIsvalidationerror,issucceeded,ishomepage,setIshomepage,isinprojectpage,setIsinprojectpage,setIssucceeded,setMenupress,popup,setPopup, isincontactpage, setIsincontactpage}}>
    <Router>

      {/* <div> */}


      {/* <WhatsAppIcon style={{position:'fixed',bottom:'20px',right:'20px',color:'#25d366',fontSize:ismd? '60px' : '45px',zIndex:'1000', cursor:'pointer'}} onClick={()=> {
            window.open("https://wa.me/972515874958")
        }} />
        */}



      {/* <div className={`content ${isLangChanging? 'lang-change-animation':''}`} style={mainContentStyle} > */}





      {/* <Header/> */}


      <Routes>
        <Route path="/" element={<WeddingRSVP />} />
        {/* <Route path="/blog" element={<Main />} />
        <Route path="/blog/detailedblog" element={<DetailedBlog />} /> */}

      </Routes>













      {/* </div> */}


      {/* 
        {
              popup && <Popup/>
           } */}








      {/* </div> */}
    </Router>
    // </AuthContext.Provider>
  );
}

export default App;
